import {Injectable} from '@angular/core';
import {MessageService} from "primeng/api";

export class timestampedString {
    constructor(public message: string, public timestamp: Date) {}
}

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private recentMessages: timestampedString[] = [];
    private messageLifetime = 5000; // 5 seconds

    constructor(private messageService: MessageService) {}

    showAlert(message: string): void {
        const now = new Date();

        // Filter out old messages
        this.recentMessages = this.recentMessages.filter(
            msg => now.getTime() - msg.timestamp.getTime() < this.messageLifetime
        );

        // Check if the same message was shown recently
        const isDuplicate = this.recentMessages.some(
            msg => msg.message === message
        );

        if (!isDuplicate) {
            this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
            // Add the new message to recentMessages
            this.recentMessages.push(new timestampedString(message, now));
        }
    }

    showTraditionalAlert(message: string) {
        alert(message);
    }
}